import React from 'react';
import { useSelector } from 'react-redux';
import LayerStyles from '../LayerStyles';
import VectorLayer from './VectorLayer';

export default function HighlightFeaturesLayer() {
  const highlightFeatures = useSelector(state => state.feature.highlightFeatures);

  return <VectorLayer features={highlightFeatures} style={LayerStyles.highlightFeature} zIndex={1001} />;
}